import { render } from "./ColumnRuleColor.vue?vue&type=template&id=32a1b78e&scoped=true&ts=true"
import script from "./ColumnRuleColor.vue?vue&type=script&lang=ts"
export * from "./ColumnRuleColor.vue?vue&type=script&lang=ts"

import "./ColumnRuleColor.vue?vue&type=style&index=0&id=32a1b78e&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a1b78e"]])

export default __exports__